
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserGroups } from '../../contexts/UserGroupContext';
import { BlkCircularProgress } from './Progress/CircularProgress';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredGroup: string;
  fallbackPath?: string;
  extendedPermission?: string | string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredGroup,
  extendedPermission,
  fallbackPath = '/',
}) => {
  const { isUserInGroup, hasAnyPermission, isLoading } = useUserGroups();

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '200px',
        }}
      >
        <BlkCircularProgress />
      </div>
    );
  }

  const hasAccess = isUserInGroup(requiredGroup);

  if (hasAccess && extendedPermission && !hasAnyPermission(extendedPermission)) {
    return <Navigate to={fallbackPath} replace />;
  }

  if (!hasAccess) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

interface UnauthorizedMessageProps {
  pageName?: string;
}

export const UnauthorizedMessage: React.FC<UnauthorizedMessageProps> = ({ pageName = 'THIS PAGE' }) => {
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>
        YOU DO NOT HAVE ACCESS TO VIEW {pageName.toUpperCase()}. PLEASE CONTACT YOUR ADMINISTRATOR TO GAIN ACCESS
      </h1>
    </div>
  );
};
